[
    {
        "icon": "bubble wcag-a",
        "attr": "A",
        "guidelineId": "QUALWEB-A"
    },
    {
        "icon": "bubble wcag-aa",
        "attr": "AA",
        "guidelineId": "QUALWEB-AA"
    },
    {
        "icon": "bubble wcag-a",
        "attr": "A",
        "guidelineId": "WCAG2-A"
    },
    {
        "icon": "bubble wcag-aa",
        "attr": "AA",
        "guidelineId": "WCAG2-AA"
    },
    {
        "icon": "bubble wcag-aaa",
        "attr": "AAA",
        "guidelineId": "WCAG2-AAA"
    },
    {
        "icon": "bubble wcag-a",
        "attr": "A",
        "guidelineId": "WCAG21-A"
    },
    {
        "icon": "bubble wcag-aa",
        "attr": "AA",
        "guidelineId": "WCAG21-AA"
    },
    {
        "icon": "bubble wcag-aaa",
        "attr": "AAA",
        "guidelineId": "WCAG21-AAA"
    },
    {
        "icon": "bubble wcag-a",
        "attr": "A",
        "guidelineId": "WCAG21-A_mobile"
    },
    {
        "icon": "bubble wcag-aa",
        "attr": "AA",
        "guidelineId": "WCAG21-AA_mobile"
    },
    {
        "icon": "bubble wcag-aaa",
        "attr": "AAA",
        "guidelineId": "WCAG21-AAA_mobile"
    }
]
